import { RoleName } from '@/api/entities/user-role-type';
import { getUserRoleTypeByName } from '@/api/user-role-type/user-role-type';
import { useQuery } from '@tanstack/react-query';

export const useGetUserRoleTypeByName = (name: RoleName) => {
  return useQuery({
    queryKey: ['getUserRoleTypeByName', name],
    queryFn: () => getUserRoleTypeByName(name),
    enabled: !!name,
  });
};
